import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]

  connect() {
    this.mediaQuery = window.matchMedia("(max-width: 767px)")
    this.handleMediaChange = this.handleMediaChange.bind(this)
    this.mediaQuery.addEventListener("change", this.handleMediaChange)
    this.updateState()
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleMediaChange)
  }

  toggle(event) {
    if (!this.mediaQuery.matches) return

    event.preventDefault()
    const fieldset = event.currentTarget.closest("fieldset")
    if (!fieldset) return

    const content = fieldset.querySelector("[data-collapsible-fieldset-target='content']")
    const icon = fieldset.querySelector("[data-collapsible-fieldset-target='toggle']")

    if (!content) return

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      if (icon) icon.textContent = "\u2212"
    } else {
      content.classList.add("hidden")
      if (icon) icon.textContent = "+"
    }
  }

  handleMediaChange() {
    this.updateState()
  }

  updateState() {
    if (this.mediaQuery.matches) {
      this.enableCollapsible()
    } else {
      this.showAll()
    }
  }

  enableCollapsible() {
    const fieldsets = this.element.querySelectorAll("fieldset")
    fieldsets.forEach((fieldset, index) => {
      const content = fieldset.querySelector("[data-collapsible-fieldset-target='content']")
      const icon = fieldset.querySelector("[data-collapsible-fieldset-target='toggle']")
      if (icon) icon.classList.remove("hidden")
      if (index === 0) {
        if (content) content.classList.remove("hidden")
        if (icon) icon.textContent = "\u2212"
      } else {
        if (content) content.classList.add("hidden")
        if (icon) icon.textContent = "+"
      }
    })
  }

  showAll() {
    this.contentTargets.forEach((content) => {
      content.classList.remove("hidden")
    })
    this.toggleTargets.forEach((icon) => {
      icon.classList.add("hidden")
    })
  }
}
